import React from "react";
import Horaire from "../assets/Horaire_v2.jpg";
import HoraireImage from "../assets/R0001518.jpg";
function PlanningSchedule() {
  return (
    <div className="planning-schedule-section">
      <div className="schedule-title-wrapper">
        <div className="schedule-title">LES HORAIRES</div>
      </div>
      <div className="schedule-content-wrapper">
        <img
          src={Horaire}
          alt="Horaire"
          className="schedule-table-image"
        />
        <img
          src={HoraireImage}
          alt="HoraireImage"
          className="schedule-side-image"
        />
      </div>
    </div>
  );
}

export default PlanningSchedule;
